import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @author ADr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, NewSalesDashboardReportConverter, NewSalesDashboardReportRowConverter, SalesDashboardReportRowDTOConverter, SalesDashboardRowsDataDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var SalesDashboardLayer =
/*#__PURE__*/
function () {
  function SalesDashboardLayer() {
    _classCallCheck(this, SalesDashboardLayer);

    this.newSalesDashboardReportConverter = new NewSalesDashboardReportConverter();
  }
  /**
   * Creates new sales dashboard report
   * @param reportType
   * @param filter
   * @returns Promise<SalesDashboardReportDTO>
   */


  _createClass(SalesDashboardLayer, [{
    key: "createReport",
    value: function createReport(reportType, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_REPORT).post({
                  filter: filter,
                  reportType: reportType
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Getter for sales dashboard report status
     * @param reportId
     * @returns Promise<ISalesDashboardReportStatus>
     */

  }, {
    key: "getReportStatus",
    value: function getReportStatus(reportId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_REPORT_STATUS(reportId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  return response.data;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Getter for sales dashboard report node
     * @param reportId
     * @param groupKeys
     * @returns Promise<List<SalesDashboardReportRowDTO>>
     */

  }, {
    key: "getReportNode",
    value: function getReportNode(reportId, groupKeys) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api(CONSTANTS.API.ENDPOINTS.SALES_DASHBOARD_REPORT_NODE(reportId)).post({
                  groupKeys: groupKeys
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return (response.data.result || []).map(function (i) {
                    return _this.reportRowDTOConverter.toObject(i, jsonConversions);
                  });
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * Creates new sales dashboard report
     * @param reportType
     * @param filter
     * @returns Promise<SalesDashboardReportDTO>
     */

  }, {
    key: "createReport_new",
    value: function createReport_new(reportType, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_SALES_DASHBOARD_REPORT).post({
                  filter: filter,
                  reportType: reportType
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this2.newSalesDashboardReportConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
    /**
     * Getter for sales dashboard report status
     * @param reportId
     * @returns Promise<ISalesDashboardReportStatus>
     */

  }, {
    key: "getReportStatus_new",
    value: function getReportStatus_new(reportId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_SALES_DASHBOARD_REPORT_STATUS(reportId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  return _this3.newSalesDashboardReportConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    }
    /**
     * Asks BE to return total count of rows in specific report, count should be based on expanded groups.
     * This method is used when AgGrid is initialized in viewport mode.
     * @param reportId
     * @param expandedGroups
     */

  }, {
    key: "getTotalRowCount",
    value: function getTotalRowCount(reportId, expandedGroups) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_SALES_DASHBOARD_REPORT_GET_TOTAL_COUNT(reportId)).post({
                  expandedGroups: expandedGroups
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return response.data.result;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
    /**
     * Ask BE to return subset of data for grid rows. Rows are specific to specific report. Subset is based
     * on limit, offset and expanded groups.
     * This method is used when AgGrid is initialized in viewport mode.
     * @param reportId
     * @param limit
     * @param offset
     * @param expandedGroups
     * @param filter
     */

  }, {
    key: "getRowsData",
    value: function getRowsData(reportId, limit, offset, expandedGroups, filter) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", api(CONSTANTS.API.ENDPOINTS.NEW_SALES_DASHBOARD_REPORT_ROW_DATA(reportId)).post({
                  expandedGroups: expandedGroups,
                  limit: limit,
                  offset: offset,
                  filter: filter
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return _this4.salesDashboardRowsDataDTOConverter.toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }]);

  return SalesDashboardLayer;
}();

__decorate([Inject, __metadata("design:type", SalesDashboardReportRowDTOConverter)], SalesDashboardLayer.prototype, "reportRowDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", SalesDashboardRowsDataDTOConverter)], SalesDashboardLayer.prototype, "salesDashboardRowsDataDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", NewSalesDashboardReportRowConverter)], SalesDashboardLayer.prototype, "newSalesDashboardReportRowConverter", void 0);